/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Box, Flex } from '@radix-ui/themes';

import { styled } from 'fierry/react';

import Empty from 'solis/react/layout/empty';
import Header from 'solis/react/layout/header';


const Root = styled(Flex)`

  flex-direction: column;
  flex-shrink: 0;

  width: 320px;

  border-right: 1px solid var(--gray-a5);
`;


const PaneContainer = styled(Box)`

  flex-grow: 1;
  overflow: auto;

  background: var(--gray-a2);
`;


export default ({ title, badge, pane: Pane = Empty }) =>
(
  <Root>

    <Header title = {title} badge = {badge} />

    <PaneContainer asChild>

      <aside>
        <Pane />
      </aside>

    </PaneContainer>

  </Root>
);
